<template>
  <a-modal
    :width="modalWidth"
    :visible="visible"
    title="标签选择"
    :confirmLoading="confirmLoading"
    @ok="typeChange"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
  >
    <!--部门树-->
    <template>
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="标签组"
        >
          <a-tree
            multiple
            treeCheckable="tree"
            checkable
            @expand="onExpand"
            :expandedKeys="expandedKeysss"
            :checkedKeys="checkedKeys"
            allowClear="true"
            :checkStrictly="true"
            @check="onCheck"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="departTree"
            placeholder="请选择上级部门"
          >
          </a-tree>
        </a-form-item>
      </a-form>
    </template>
    <a-modal
      :width="modalWidth"
      :visible="show"
      title="确定框"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel1"
      cancelText="关闭"
      wrapClassName="ant-modal-cust-warp"
      >{{ this.text }}
    </a-modal>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick';
import { getCusAll } from '@/api/api';
import userModal from '../../system/modules/UserModal';

export default {
  name: 'CustomerWindow',
  components: {
    userModal
  },

  data() {
    return {
      key: '',
      text: '',
      show: false,
      checkedList: [],
      selectedRowKeys: [],
      checkedKeys: [], // 存储选中的部门id
      expandedKeysss: [], //展开的节点
      userId: '', // 存储用户id
      model: {}, // 存储SysUserDepartsVO表
      userDepartModel: { userId: '', departIdList: [] }, // 存储用户id一对多部门信息的对象
      departList: [], // 存储部门信息
      parentName: [], //存储父节点名子
      modalWidth: 400,
      departTree: [],
      title: '操作',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        userId: process.env.VUE_APP_CMS_SYSTEM + '/wechatworkapi/cusGroupChat/' // 引入生成添加用户情况下的url
      }
    };
  },
  mounted() {
    this.queryDepartTree();
  },
  // inject: ['reload'],
  methods: {
    add(record) {
      this.edit(record);
    },
    typeChange(e) {
      this.show = true;
      this.text = '确定选项吗？';
    },
    edit(record) {
      this.key = record.chat_id;
      this.departList = [];
      this.visible = true;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      let filedsVal = pick(this.model, 'id', 'userId', 'departIdList');
      this.$nextTick(() => {
        this.form.setFieldsValue(filedsVal);
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.departList = [];
      this.checkedKeys = [];
    },
    handleSubmit(record) {
      this.show = false;
      this.confirmLoading = true;
      let formData = new FormData();
      formData.selectedRowKeys = this.checkedKeys;
      formData.departIdList = this.departList;
      formData.key = this.key;
      this.$emit('ok', formData);
      this.confirmLoading = false;
      this.close();
    },
    handleCancel() {
      this.close();
    },

    handleCancel1() {
      this.show = false;
    },
    // 选择部门时作用的API
    onCheck(checkedKeys, info) {
      this.departList = [];
      this.checkedKeys = checkedKeys.checked;
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = { key: '', value: '', title: '', parentName: '' };
        depart.key = de.value;
        depart.value = de.value;
        depart.title = de.title;
        depart.parentName = de.dataRef.parentid;
        this.departList.push(depart);
      }
      console.log('onCheck', checkedKeys, info);
    },
    queryDepartTree() {
      getCusAll().then(res => {
        if (res.success) {
          this.departTree = res.result;
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach(item => {
                treekey.push(item.key);
              });
              this.expandedKeysss = treekey;
            }
          }
        }
      });
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
    }
  }
};
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
